<div fxLayout="column" fxLayoutAlign="start start" class="w-100 h-100">
        <div class="container mt-24">
            <div class="fraud-report-total-container"
                 fxLayout="row" fxLayoutAlign="space-between center">
                <div class="t2-semi-bold">{{ 'i18n_af_labelTotalFraudReportRows' | translate }}</div>
                <div class="t1-semi-bold">{{ totalElements }}</div>

            </div>
            <div class="fraud-report-total-amount-container"
                 fxLayout="row" fxLayoutAlign="space-between center">
                <div class="t2-semi-bold">{{ 'i18n_af_labelTotalFraudReportAmount' | translate }}</div>
                <div class="t1-semi-bold">{{ formatTiynAsTenge(totalAmount) }}</div>
            </div>
        </div>
        <af-full-table
            class="w-100 h-100"
            [filterFields]="filterFields"
            (tableUpdateListener)="loadReportData($event)"
            [dataSource]="dataSource"
            [totalElements]="totalElements"
            [filterEvent]="filterHolderService.getState(fraudReport.id, currentTab)?.tableEvent?.filter"
            [pageEvent]="filterHolderService.getState(fraudReport.id, currentTab)?.tableEvent?.page"
            [sortEvent]="filterHolderService.getState(fraudReport.id, currentTab)?.tableEvent?.sortBy"
            [showImport]="false"
            [showExport]="false"
            [columnTranslationPrefixes]="reportSection === 'REFUNDS' ? {transactionType: 'refunds'} : {}"
            emptyStateIconName="ic_empty_state_no_data"
            emptyStateTitleTranslationKey="i18n_af_emptyStateSubtitleNoData"
            placeholderContext="fraudReportData"/>
</div>


